
import tiktokPostContainer from '@/components/tiktok-post/index.vue';
import { computed, defineComponent } from 'vue-demi';
import identityStore from '@/store/modules/identity';
import { useIdentityHooks } from '@/hooks/global/useIdentityHooks';
const name = 'creation-tiktok-post-data-wraper';
export default defineComponent({
  name,
  components: {
    tiktokPostContainer,
  },
  props: {},
  setup() {
    const { displayName, avatarIconUrl, identityNotAvailable, nativeVideoList } = useIdentityHooks();
    const videoList = computed(() => identityStore.getters.identityFormData.value.nativeVideoList);

    return {
      videoList,
      displayName,
      avatarIconUrl,
      nativeVideoList,
      identityNotAvailable,
    };
  },
});
